import cn from 'classnames';
import { useEffect, useState } from 'react';
import calendar from '../../../../assets/media/icons/calendar.svg';
import Row from '../../Blocks/Row';
import CalendarDay from '../../Elements/Calendar';
import Input from '../Base';
import styles from './styles.module.scss';

export const formString = (data) => (data < 10 ? `0${data}` : data);

export const formDate = (date_str) => {
  if (date_str === undefined || date_str === null) {
    return null;
  }
  const date = new Date(date_str);

  let day = date.getDate();
  day = formString(day);

  let month = date.getMonth() + 1;
  month = formString(month);

  const year = date.getFullYear();

  return [day, month, year].join('.');
};

export default function DateInput({
  style,
  onChange = () => { },
  value,
  disabled = false,
  classNameCalendar,
  ...props
}) {
  const [open, changeOpen] = useState(false);
  const [day, changeDay] = useState(value);

  useEffect(() => {
    changeDay(value);
  }, [value]);

  return (
    <Row styles={cn(styles.data_input, classNameCalendar)} onClick={() => changeOpen(true)}>
      <Input {...props} paddingLeft="30px" cursor="pointer" value={day ? formDate(day) : ''} readOnly={true} />
      <img src={calendar} alt="" className={styles.data_symbol_img} />
      {open && (
        <CalendarDay
          changeCb={(data) => {
            changeDay(data);
            onChange(Date.parse(data));
          }}
          date={day}
          disabled={disabled}
          closeCb={() => changeOpen(false)}
          {...props}
        />
      )}
    </Row>
  );
}
